<template>
    <CardContentPanel icon="add-circle" v-bind="{action, index}">
        <template #title>{{ $t('projectclient.projectview.activity.pending.actions.ADD_PURCHASE_ORDER.title') }}</template>
        <template #body>{{ $t('projectclient.projectview.activity.pending.actions.ADD_PURCHASE_ORDER.description') }}</template>
        <template #actions>
            <NuxtLink :to="`/project/${projectInformation.projectId}/details?from=tasks`">
                <VJoyButton variant="main" size="small" data-testid="pending-action-card-cta-primary">
                    {{ $t('projectclient.projectview.activity.pending.actions.ADD_PURCHASE_ORDER.action.primary') }}
                </VJoyButton>
            </NuxtLink>
        </template>
    </CardContentPanel>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyButton} from '@maltjoy/core-vue';
    import CardContentPanel from '../CardContentPanel.vue';
    import {useProjectInformationStore} from '@/common/stores';
    import type {ActivityPendingActionByType} from '@/features/project-view';

    defineProps<{
        action: ActivityPendingActionByType<'ADD_PURCHASE_ORDER'>;
        index: number;
    }>();

    const projectInformationStore = useProjectInformationStore();
    const {projectInformation} = storeToRefs(projectInformationStore);
</script>
